import React, { useState ,useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import infoLogo from "../../../assets/images/info.png";
import warningLogo from "../../../assets/images/warning.png";
import {FormattedMessage} from "react-intl";
import {Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import {config} from "../../../utility/swaggerClient";

const ModalExample = (props) => {
  const {
    buttonLabel,
    className,
    size,
    warning,
    info,
    confirmation,
    isText,
    hasTitle,
    stagingprj,
    store
  } = props;

  const [modal, setModal] = useState(false);
  const [infoText, setInfoText] = useState("Select source code staging project names:");
  const [warningText, setWarningText] = useState("Exception");
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMesssage] = useState("");


  const toggle = () => setModal(!modal);

  const close = ()=>{
    let body ={};
    if(message === ""){
      setMesssage(" ");
    }
    if(!store.getState().shift.auth.authenticated){
      body=JSON.stringify({
        firstNameAndLastName : name,
        companyName: company,
        corporateEmail: email,
        message
      })
    }else{
      body=JSON.stringify({
        firstNameAndLastName : store.getState().shift.auth.firstname + store.getState().shift.auth.lastname,
        companyName: store.getState().shift.auth.customerid,
        corporateEmail: store.getState().shift.auth.email,
        message
      })
    }

    let requestOptions;
    if(sessionStorage.getItem('jwt') !== null){
      requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
        body
      };
    }else{
      requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body
      };
    }

    fetch(`${config.protocol}://${config.host}/api/user/contactus`, requestOptions)
      .then(data => {
        toggle();
        setName("");
        setCompany("");
        setEmail("");
        setMesssage("");
      });
  }


  useEffect(() => {

  }, []);

  return (

    <a>
      <div style={{cursor: 'pointer', display: 'inline-block'}} onClick={toggle}>Contact Us</div>
      <Modal isOpen={modal} toggle={toggle} className={className} >
        {hasTitle && (
          <ModalHeader toggle={toggle}>
            <div style={{width: "450px"}}><img alt="SHIFT" src={infoLogo} className="modal_logo"/>
              <i>SEND US A MESSAGE</i>
            </div>
            {warning &&(<div style={{width: "372px"}}><img alt="SHIFT" src={warningLogo} className="modal_logo"/>{warningText} </div>)}
          </ModalHeader>
        )}
        <ModalBody style={{overflow:'auto'}}>
          <Form>
            {!store.getState().shift.auth.authenticated && (
              <div>
                <FormGroup>
                  <Input placeholder="First and Last Name" value={name} onChange={(e)=>{setName(e.target.value)}}/>
                </FormGroup>
                <FormGroup>
                  <Input placeholder="Company Name" value={company} onChange={(e)=>{setCompany(e.target.value)}}/>
                </FormGroup>
                <FormGroup>
                  <Input type="email" placeholder="Corporate Email" value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
                </FormGroup>
              </div>
            )}


            <FormGroup>
              <Input type="textarea"  placeholder="Message" style={{height: '200px'}}
                     value={message}
                     onChange = {(e)=>{setMesssage(e.target.value)}}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          {!store.getState().shift.auth.authenticated && (
            <button
              className="button"
              style={{ marginLeft : "auto", marginRight : "auto"}}
              type="button"
              onClick={close}
              disabled={message === "" || name==="" || company==="" || email===""}
            >
              <FormattedMessage id="contactus" defaultMessage="OK" />
            </button>
          )}

          {store.getState().shift.auth.authenticated && (
            <button
              className="button"
              style={{ marginLeft : "auto", marginRight : "auto"}}
              type="button"
              onClick={close}
              disabled={message === ""}
            >
              <FormattedMessage id="contactus" defaultMessage="OK" />
            </button>
          )}

        </ModalFooter>
      </Modal>
    </a>
  );
}

export default ModalExample;



// WEBPACK FOOTER //
// ./src/components/views/Footer/popup.js